module.exports = __webpack_public_path__ + "img/private-02.d311c26f.jpg";